/** Hilfen für Freigabe-Aufgaben (digitale Mitarbeiter übergeben an Menschen). */

export type BelegZiel =
  | { art: 'auftrag'; id: number }
  | { art: 'ausgangsrechnung'; id: number; url: string };

export function istFreigabeAufgabe(a: { entitaet_typ: string }): boolean {
  return a.entitaet_typ === 'freigabe';
}

/** Wohin führt „Zum Auftrag“ / „Zum Beleg“? Es gibt keinen Router: der Auftrag
 *  wird per navigiereZuAuftrag geöffnet, die Rechnung im Beleg-Modal (url ohne
 *  API_URL-Prefix, wie bei DokumenteOverview). */
export function belegZiel(entitaetTyp: string | null, entitaetId: number | null): BelegZiel | null {
  if (!entitaetTyp || entitaetId == null) return null;
  if (entitaetTyp === 'auftrag') return { art: 'auftrag', id: entitaetId };
  if (entitaetTyp === 'ausgangsrechnung') {
    return {
      art: 'ausgangsrechnung',
      id: entitaetId,
      url: `/api/dokumente/ausgangsrechnungen/${entitaetId}/beleg-ansicht`,
    };
  }
  return null;
}
